export const PATH = {
  ROOT: "/",
  LANDING: "/",

  SIGNUP: "/sign-up",
  SIGNIN: "/sign-in",
} as const;
